// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { list, $delete, createOrUpdate, get } from "./operations.js";
export {
  TargetsListOptionalParams,
  TargetsDeleteOptionalParams,
  TargetsCreateOrUpdateOptionalParams,
  TargetsGetOptionalParams,
} from "./options.js";
